import { API_URL_NEWS } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";

const getNews = () =>
  apiInstance({
    url: API_URL_NEWS,
    params: {
      limit: 1000,
      sort: "date",
      order: -1,
    },
  });

export default getNews;
